// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


//配置配置图标库
import 'font-awesome/css/font-awesome.min.css'
// 导入 ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 使用 ElementUI
Vue.use(ElementUI);


// 全局引入 echarts
import * as echarts from 'echarts'
// 将 echarts 挂载到 Vue 上
Vue.prototype.$echarts = echarts



// 引入 axios
import axios from 'axios'
// 将 axios 挂载到 Vue 上
Vue.prototype.$axios = axios
// 设置接口请求的前缀地址
// axios.defaults.baseURL = 'http://127.0.0.1:9258/api'
// 全局设置token 
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem('token')
  if (token) {
    config.headers['token'] = token
    config.headers.Authorization = token
  }
  return config
})


import App from './App'
import router from './router'

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js